import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/utils/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'w-full rounded-xl border border-border bg-zinc-50 px-4 py-2.5 text-sm transition-all placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-amber-400/40 dark:bg-zinc-900',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
